import DropdownMenu from 'common/components/drop-downs/drop-down-menu';
import DropdownMenuButton from 'common/components/drop-downs/dropdown-menu-button';
import Textbox from 'common/components/inputs/textbox';
import { SegmentControlsFilterValueOperators } from 'features/segment-controls/constants/segment-controls-filter-value-operators';
import { useState } from 'react';
import { SegmentFilterValue } from '../../segment-controls.types';
import { ButtonTheme } from 'common/components/buttons/button-theme';
import Button from 'common/components/buttons/button';

interface SegmentControlFilterValueProps {
  filterValue: SegmentFilterValue;
  isFirstFilterValue: boolean;
  onFilterValueChanged: (newFilterValue: SegmentFilterValue) => void;
  onDeleteFilterValue: (filterValue: SegmentFilterValue) => void;
}

const SegmentFilterValueDropdown = ({
  filterValue,
  isFirstFilterValue,
  onFilterValueChanged,
  onDeleteFilterValue
}: SegmentControlFilterValueProps) => {
  const valueOperators = Object.entries(SegmentControlsFilterValueOperators);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const onOperatorChanged = (
    newOperator: SegmentControlsFilterValueOperators
  ) => {
    const newFilterValue: SegmentFilterValue = {
      ...filterValue,
      valueOperator: newOperator
    };
    onFilterValueChanged(newFilterValue);
  };

  const onValueChanged = (newValue: string) => {
    const newFilterValue: SegmentFilterValue = {
      ...filterValue,
      value: newValue
    };
    onFilterValueChanged(newFilterValue);
  };

  const handleDeleteFilterValue = () => {
    onDeleteFilterValue(filterValue);
  };

  return (
    <div className="flex items-stretch">
      <DropdownMenu
        isDropdownOpen={isDropdownOpen}
        containerClasses="flex justify-center relative w-25"
        buttonClasses="w-60 flex items-center flex-row-reverse justify-center py-2 px-3 bg-white rounded border border-neutral-200 rounded-r-none border-r-0 text-sm"
        buttonIconClasses="ra-icons-generic-down-arrow text-bottom text-xs flex"
        buttonLabel={filterValue.valueOperator}
        buttonLabelClasses="text-sm mr-2 capitalize"
        dropdownMenuClasses="z-40 top-11 left-0 w-25"
        onDropdownClicked={() => setIsDropdownOpen(!isDropdownOpen)}
        onClickAway={() => setIsDropdownOpen(false)}
      >
        {valueOperators.map(([_, valueOperator], valueOperatorIndex) => (
          <DropdownMenuButton
            key={`segment-value-operator-${valueOperatorIndex}`}
            identifier={`segment-value-operator-${valueOperatorIndex}`}
            buttonClasses="flex items-center"
            onClick={() => {
              onOperatorChanged(valueOperator);
              setIsDropdownOpen(false);
            }}
          >
            <span className="capitalize text-sm">{valueOperator}</span>
          </DropdownMenuButton>
        ))}
      </DropdownMenu>
      <Textbox
        identifier="segment-value-text"
        errors={[]}
        placeholder={
          filterValue.valueOperator ===
          SegmentControlsFilterValueOperators.CONTAINS
            ? 'E.g. goog... (not case sensitive)'
            : 'E.g. Google Paid... (case sensitive)'
        }
        value={filterValue.value}
        inputClassOverrides="flex grow w-full border rounded px-4 py-2 text-xs rounded-l-none mr-2"
        containerClass="flex grow"
        onChange={onValueChanged}
      />
      {!isFirstFilterValue ? (
        <Button
          identifier={`delete-filter-${filterValue.value}`}
          theme={ButtonTheme.CANCEL}
          onClick={handleDeleteFilterValue}
        >
          <i className="flex items-center ra-icons-generic-bin"></i>
        </Button>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SegmentFilterValueDropdown;
